export const trialConfig = {
    // freeTrialMinutesAfterStart: 10,
    freeTrialSecondsAfterStart: 30,
    extraTrialDays: 7,
};
